import axios from "axios";
import { NotImplementedError } from "../..";
import { PromiseHandler } from "../../handlers";
import { AgentSessionsFetchFailedError } from "./errors";
import { handleAgentSessionRequestError } from "./errors";
/**
 * Module for fetching agent session lists.
 * Use this module when fetching multiple agent sessions.
 * This module returns a list of agent session summaries.
 * For complete session data, use the `AgentSessions` class.
 */
export class AgentSessionsLists extends PromiseHandler {
    constructor(sdk, agent) {
        super(sdk, `ai.agents.${agent}.lists`);
        /**
         * @deprecated find_once is not supported for `AgentSessionsLists` since it is designed to return multiple sessions.
         * Use the `AgentSessions` class which supports `find_once` for fetching a single session by ID.
         * @throws {NotImplementedError} Always, since this method is not implemented for `AgentSessionsLists`.
         */
        this.find_once = (_filters, _hydratedFields) => {
            throw new NotImplementedError("find_once is not implemented for AgentSessionsLists. Use AgentSessions instead.");
        };
        /**
         * @deprecated Saving agent sessions directly through `AgentSessionsLists` is not supported.
         * Use the `AgentSessions` class to manage individual sessions and prompt the agent.
         */
        this.save = (_data, _options) => {
            throw new NotImplementedError("AgentSessionsLists does not support saving sessions directly. Use AgentSession instead to prompt sessions.");
        };
        this.agentName = agent;
    }
    get agent() {
        return this.agentName;
    }
    /**
     * Finds agent sessions
     * @throws {AgentSessionsFetchFailedError} If there was an error fetching the session.
     * @throws {UnauthenticatedError} If the user is not authenticated.
     * @returns the agent sessions matching the provided filters.
     */
    async findItems(_filters, _sort) {
        const url = `${this.sdk.urls.baseAiAgentsUrlLegacy}/${this.agent}/sessions`;
        return this.cache.promise(url, async () => {
            try {
                const res = await axios.get(url, this.sdk.ai.axiosRequestConfig(this.agent, { legacy: true }));
                const items = (res.data || []);
                return items.map(fromLegacyListItem);
            }
            catch (err) {
                handleAgentSessionRequestError(err, {
                    defaultError: new AgentSessionsFetchFailedError()
                });
            }
        });
    }
    /**
     * @deprecated
     */
    async saveItem(_data, _options) {
        throw new NotImplementedError("AgentSessionsLists does not support saving sessions directly. Use AgentSession instead to prompt sessions.");
    }
    /**
     * @deprecated Deleting agent sessions is not supported.
     */
    async deleteItem(_id) {
        throw new NotImplementedError("AgentSessionsLists does not support deleting sessions directly. Use AgentSession instead to manage sessions.");
    }
}
function fromLegacyListItem(item) {
    return {
        id: item.id,
        appName: item.appName,
        userId: item.userID,
        lastUpdateTime: item.lastUpdatedTime ? new Date(item.lastUpdatedTime).getTime() : undefined
    };
}
//# sourceMappingURL=sessions.lists.js.map